import {
    BLACKLIST_LOADING,
    BLACKLIST_LOADED,
    BLACKLIST_DELETED,
    BLACKLIST_SEARCHED,
    BLACKLIST_CREATED,
    BLACKLIST_FAILED,
    LOGOUT,
} from '../types';

import { createPaginated, deletePaginated } from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    allBlacklists: null,
    searchResults: null,
    success: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case BLACKLIST_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
            };
        case BLACKLIST_LOADED:
            return {
                ...state,
                success: false,
                loading: false,
                allBlacklists: action.payload,
            };
        case BLACKLIST_SEARCHED:
            return {
                ...state,
                loading: false,
                searchResults: action.payload,
            };
        case BLACKLIST_CREATED:
            return {
                ...state,
                sucess: true,
                loading: false,
                allBlacklists: createPaginated(state.allBlacklists, action.payload),
            };
        case BLACKLIST_DELETED:
            return {
                ...state,
                loading: false,
                allBlacklists: deletePaginated(state.allBlacklists, action.payload),
            };
        case BLACKLIST_FAILED:
            return {
                ...state,
                success: false,
                loading: false,
            };
        case LOGOUT:
            return {
                loading: false,
                allBlacklists: null,
                searchResults: null,
                success: false,
            };
        default:
            return state;
    }
}